import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect } from "react";
export default function Industries() {
  //  useEffect(() => {
  //       window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  //     }, []);
  const industries = [
    { label: "Technology & AI", icon: "🤖", href: "/industries/technology" },
    { label: "E-commerce & Retail", icon: "🛒", href: "/industries/ecommerce" },
    { label: "Healthcare", icon: "🩺", href: "/industries/healthcare" },
    { label: "Automotive", icon: "🚗", href: "/industries/automotive" },
    { label: "Media & Entertainment", icon: "🎬", href: "/industries/media" },
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-black via-gray-900 to-black text-white">
      {/* Section Header */}
      <div className="max-w-4xl mx-auto text-center mb-16">
        <h2 className="text-4xl font-extrabold tracking-tight font-orbitron text-white">
          Industries We Serve
        </h2>
        <p className="text-lg text-gray-300 mt-4">
          Our expertise spans across sectors where precision, culture, and AI innovation intersect.
        </p>
      </div>

      {/* Industry Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {industries.map(({ label, icon, href }, index) => (
          <Link key={index} to={href}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              className="bg-gray-800 rounded-2xl shadow-md p-8 text-center transition cursor-pointer hover:shadow-xl border border-gray-700"
            >
              {/* Animated Icon */}
              <motion.div
                className="text-4xl mb-4"
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ repeat: Infinity, duration: 2, delay: index * 0.3 }}
              >
                {icon}
              </motion.div>

              {/* Label */}
              <p className="text-lg font-semibold text-white">{label}</p>
            </motion.div>
          </Link>
        ))}
      </div>
    </section>
  );
}
